import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PreviousUrlService {
  private previousUrl: string | null = null;
  private currentUrl: string | null = null;

  constructor(private router: Router) {
    this.previousUrl = this.extractPathFromReferrer();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        if (this.currentUrl !== event.url) {
          if (this.currentUrl !== null) {
            this.previousUrl = this.currentUrl;
          }
          this.currentUrl = event.url;
        }
      });
  }

  private extractPathFromReferrer(): string | null {
    const referrer = document.referrer;
    if (!referrer) return null;
    const url = new URL(referrer);
    if (url.origin === window.location.origin) {
      return url.pathname;
    }

    return null;
  }

  getPreviousUrl(): string | null {
    return this.previousUrl;
  }
}
